import React from 'react';
import SponsorshipOptionContainer from '../../../Containers/UserContainer/SponsorshipOption';

const SponsorshipOptionScreen = () => {
  return <SponsorshipOptionContainer />;
};

export default SponsorshipOptionScreen;
